import { useDroppable } from '@dnd-kit/core';
import React from 'react';

type DroppableAreaProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
  isCompleted?: boolean;
  onComplete?: () => void;
};

export default function DroppableArea({
  id,
  children,
  className = '',
  isCompleted,
}: DroppableAreaProps) {
  const { setNodeRef } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      className={`flex w-full flex-wrap items-center justify-center gap-2 p-6 rounded-2xl min-h-32 ${
        isCompleted ? 'bg-green-100' : 'bg-gray-50'
      } ${className}`}
    >
      {children}
    </div>
  );
}